import { useEffect, useState } from "react";
import { FaBars, FaBell, FaQuestionCircle } from "react-icons/fa";
import { IoMdArrowBack } from "react-icons/io";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CountdownTimer from "../../../components/CountdownTimer";

export default function Header({ toggleSidebar, title }) {
  const [isDashboardHomePage, setIsDashboardHomePage] = useState(true);
  const isDemoAccount = useSelector(
    (state) => state?.auth?.loggedInUser?.isDemoAccount
  );
  const expireTime = useSelector(
    (state) => state?.auth?.loggedInUser?.demoExpireTime
  );
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  useEffect(() => {
    if (pathname === "/new-admin-dashboard") {
      setIsDashboardHomePage(false);
    } else {
      setIsDashboardHomePage(true);
    }
  }, [pathname]);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <header className="bg-white border-b flex items-center justify-between p-[13px]">
      <div className="flex items-center">
        {isMobile && (
          <button
            onClick={toggleSidebar}
            className="mr-4 text-gray-600 hover:text-gray-900 focus:outline-none"
          >
            <FaBars size={20} />
          </button>
        )}

        <h1 className="text-xl font-semibold">{title}</h1>
      </div>

      <div className="flex items-center space-x-4">
        {isDemoAccount && <CountdownTimer endTime={expireTime} />}
        {isDemoAccount && (
          <div>
            <button className="text-nowrap border bg-orange-400 hover:bg-orange-500 transition-all duration-100 ease-in-out text-white font-bold px-2 py-3 uppercase text-xs rounded-lg">
              Demo Account
            </button>
          </div>
        )}
        {isDashboardHomePage && (
          <button
            className="flex justify-center items-center gap-2  bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center gap-2 transition-colors"
            onClick={handleGoBack}
          >
            <div>
              <IoMdArrowBack />
            </div>
            <p>Back</p>
          </button>
        )}
      </div>
    </header>
  );
}
